// SearchBar.js
import React from "react";
// import './SearchBar.css'; // optional for custom styles

const SearchBar = () => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="kpi-heading">Invoices</h5>
      <div className="d-flex gap-2">
        <div className="position-relative">
          <input
            type="text"
            className="form-control ps-5"
            placeholder="Search"
          />
          <span className="position-absolute top-50 start-0 translate-middle-y ps-3 text-muted">
            <i className="bi bi-search"></i>
          </span>
        </div>
        <div>
          <select
            className="form-select w-auto"
            // value={filterValue}
            // onChange={(e) => setFilterValue(e.target.value)}
          >
            <option value="category">Category Wise</option>
            <option value="product">Product Wise</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
